import React, { useState, useEffect, Fragment, useRef } from "react";
import "./SideNavigation.scss";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faUserGear,
  faGear,
  faUpload,
  faShareNodes,
  faPersonShelter,
  faHotel,
  faHatWizard,
  faHandshake,
  faImage,
  faBellConcierge,
  faDesktopAlt,
  faImages,
  faDoorOpen,
  faList,
  faPeopleGroup,
  faCity,
  faMobileAndroidAlt,
  faMessage,
  faListCheck,
  faSheetPlastic,
  faArrowsRotate,
  faTableColumns
} from "@fortawesome/free-solid-svg-icons";
import { isValidRole, getUserRoleCodeFromStorage, isAutoModeViewerRoleCode } from "../../../utils/utils";
import { useSelector } from "react-redux";
import { MdOutlineContentPasteSearch } from "react-icons/md";
// import { useSelector } from "react-redux";

function SideNavigation() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isActive, setIsActive] = useState(location?.pathname);
  const [collapseEnter, setCollapseEnter] = useState(false);
  const [collapseLeave, setCollapseLeave] = useState(false);
  const [openSubmenuIndex, setOpenSubmenuIndex] = useState(null);

  const { viewType } = useSelector((state) => state.viewTypeReducer);

  const [viewTypePermission, setViewTypePermission] = useState(false)

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false
      // console.log(localStorage.getItem("viewType"))
      setViewTypePermission(localStorage.getItem("viewType") === "hotelApp" ? false : true)
    }
    else {
      if (viewType === "hotelApp") {
        setViewTypePermission(false)
      }
      else {
        setViewTypePermission(true)
      }
    }
  }, [viewType])

  // const chainIdHotelNameMapping = JSON.parse(localStorage.getItem("userDetails"))?.chainIdHotelNameMapping[0]?.viewType;
  // const viewTypePermission = viewType === "hotelApp" || chainIdHotelNameMapping === "hotelApp" ? false : true
  // const viewTypePermission = viewType === "hotelApp" ? false : true
  const userRoleCode = getUserRoleCodeFromStorage();

  // const { hotelChainId } = useSelector((state) => state.hotelChainIdReducer);

  useEffect(() => {
    setIsActive(location.pathname);
  }, [location]);

  const mockData = [
    {
      label: "Dashboard",
      icon: faTableColumns,
      iconType: "fontawesome",
      subMenu: true,
      to: "",
      permissionAvailable: isValidRole("MENU_HOTEL_DASHBOARD"),
      childMenu: [
        {
          subLabel: "Hotels Dashboard",
          to: "/hms/Dashboard/Hotels_Dashboard",
          permissionAvailable: true ,
        },
        {
          subLabel: "Automode Dashboard",
          to: "/hms/Dashboard/Automode_Dashboard",
          permissionAvailable: true ,
        },
        {
          subLabel: "APK Version Dashboard",
          to: "/hms/Dashboard/APK_Version_Dashboard",
          permissionAvailable: true ,
        },
        {
          subLabel: "Asset Management Dashboard",
          to: "/hms/Dashboard/AssetManagement_Dashboard",
          permissionAvailable: true ,
        },
        {
          subLabel: "Test/Demo Hotels Dashboard",
          to: "/hms/Dashboard/Test_Demo_Hotels_Dashboard",
          permissionAvailable: true ,
        },
      ]
    },
    {
      label: "Hotel Configuration",
      icon: faHotel,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/ConfigurationNewHotel",
      permissionAvailable: isValidRole("MENU_CONFIGURATION_NEW_HOTEL"),
    },
    {
      label: "Hotel Onboarding Wizard",
      icon: faHatWizard,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/HotelOnboardingWizard",
      permissionAvailable: isValidRole("MENU_CONFIGURATION_NEW_HOTEL") && userRoleCode !== "ROLE_SUPER_ADMIN",
    },
    {
      label: "Master APK Configuration",
      icon: faMobileAndroidAlt,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/ConfigurationMasterApk",
      permissionAvailable: isValidRole("MENU_MASTER_APK_CONFIGURATION") && userRoleCode !== "ROLE_SUPER_ADMIN" && !viewTypePermission,
    },
    {
      label: "Room Configuration",
      icon: faPersonShelter,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/ConfigurationNewRoom",
      permissionAvailable: isValidRole("MENU_CONFIGURATION_NEW_ROOM") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    {
      label: "Welcome Screen Config",
      icon: faDoorOpen,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/WelcomeScreenConfig",
      permissionAvailable: isValidRole("MENU_CUSTOMIZE_WELCOME_SCREEN") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    {
      label: "Welcome Message",
      icon: faUpload,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/WelcomeMessages",
      permissionAvailable: isValidRole("MENU_WELCOME_MESSAGES") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    {
      label: "Hero Banner",
      icon: faGear,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/HeroBanner",
      permissionAvailable: isValidRole("MENU_CONFIGURATION_MANAGEMENT") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    
    {
      label: "Rail Configuration",
      icon: faImage,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/RailConfiguration",
      permissionAvailable: isValidRole("MENU_CONFIGURATION_RAIL") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    {
      label: "Hotel Services",
      icon: faBellConcierge,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/HotelServiceConfiguration",
      permissionAvailable: isValidRole("MENU_CONFIGURATION_HOTEL_SERVICE") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    {
      label: "Hotel Channels",
      icon: faShareNodes,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/HotelChannels",
      permissionAvailable: isValidRole("MENU_CONFIGURATION_HOTEL_CHANNEL") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    {
      label: "Screensaver",
      icon: faDesktopAlt,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/ScreensaverConfiguration",
      permissionAvailable: isValidRole("MENU_CONFIGURATION_MASTER_SCREENSAVER") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    {
      label: "Background Image",
      icon: faImages,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/ConfigurationBackgroundImage",
      permissionAvailable: isValidRole("MENU_CONFIGURATION_MASTER_BACKGROUND_IMAGE") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    {
      label: "City Configuration",
      icon: faCity,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/cityConfiguration",
      permissionAvailable: isValidRole("MENU_CITY_CONFIGURATION") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    {
      label: "Group Rooms",
      icon: faPeopleGroup,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/GroupRooms",
      permissionAvailable: isValidRole("MENU_GROUP_ROOMS") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    },
    {
      label: "CDSN Level Configurations",
      icon: '',
      iconType: "reactIcon",
      subMenu: false,
      to: "/hms/fetchcdsndetails",
      permissionAvailable: userRoleCode === "ROLE_SUPER_ADMIN" && isValidRole("CDSN_DETAILS_CONFIGURATION") && !isAutoModeViewerRoleCode(userRoleCode),
    },
    {
      label: "SID-CDSN Details",
      icon: faListCheck,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/fetchcdsndetailsAdmin",
      permissionAvailable: isValidRole("SID_CDSN_DETAILS") && !isAutoModeViewerRoleCode(userRoleCode),
    },
    {
      label: "Auto Mode Report",
      icon: faSheetPlastic,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/APKInstallationDetails",
      permissionAvailable: isValidRole("AUTO_MODE_REPORT") || isAutoModeViewerRoleCode(userRoleCode),
    },
    {
      label: "Re-Sync Chain ID",
      icon: faArrowsRotate,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/resyncchainid",
      permissionAvailable: isValidRole("RE_SYNC_CHAINID"),
    },
    {
      label: "Activity Logs",
      icon: faMessage,
      iconType: "fontawesome",
      subMenu: false,
      to: "/hms/activityLogs",
      permissionAvailable: userRoleCode === "ROLE_SUPER_ADMIN" ? true : false,
    },
    // {
    //   label: "Guest Message",
    //   icon: faMessage,
    //   iconType: "fontawesome",
    //   subMenu: false,
    //   to: "/hms/guestMessage",
    //   permissionAvailable: isValidRole("MENU_GUEST_MESSAGE") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
    // },
    {
      label: "Master Configurations",
      icon: faHandshake,
      iconType: "fontawesome",
      subMenu: true,
      to: "",
      permissionAvailable: isValidRole("MENU_CONFIGURATION_MASTER") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
      childMenu: [
        {
          subLabel: "Default Config",
          // icon: faList,
          // iconType: "fontawesome",
          // subMenu: false,
          to: "/hms/DefaultConfig",
          permissionAvailable: isValidRole("MENU_DEFAULT_CONFIGURATION") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
        },
        {
          subLabel: "Whitelist Domain",
          to: "/hms/WhitelistDomain",
          permissionAvailable: userRoleCode === "ROLE_SUPER_ADMIN" ,
        },
        {
          subLabel: "OTT Apps",
          to: "/hms/PartnerConfiguration",
          permissionAvailable: isValidRole("MENU_CONFIGURATION_MASTER_PARTNER"),
        },
        {
          subLabel: "Room Type",
          to: "/hms/RoomTypeConfiguration",
          permissionAvailable: isValidRole("MENU_CONFIGURATION_MASTER_ROOM_TYPE"),
        },
        {
          subLabel: "APK Provider Configuration",
          to: "/hms/APKProviderConfiguration",
          permissionAvailable: isValidRole("MENU_CONFIGURATION_MASTER_APK_PROVIDER"),
        },
        {
          subLabel: "Third Party Hotel Configuration",
          to: "/hms/thirdPartyHotelConfiguration",
          permissionAvailable: isValidRole("MENU_CONFIGURATION_MASTER_THIRD_PARTY_HOTEL"),
        },
        {
          subLabel: "Utilities",
          to: "/hms/UtilityServiceConfiguration",
          permissionAvailable: isValidRole("MENU_CONFIGURATION_MASTER_UTILITIES"),
        },
        {
          subLabel: "Satellite Channel Mapping",
          to: "/hms/SatelliteChannelMapping",
          permissionAvailable: userRoleCode === "ROLE_SUPER_ADMIN" || isValidRole("MENU_CONFIGURATION_MASTER_SATELLITE_CHANNEL_MAPPING"),
        },
        {
          subLabel: "Software Stack Details",
          to: "/hms/SoftwareStackDetails",
          permissionAvailable: userRoleCode === "ROLE_SUPER_ADMIN" || isValidRole("SOFTWARE_STACK_DETAILS"),
        }
        // {
        //   subLabel: "Manual CDSN Mapping",
        //   to: "/hms/ManualCDSNMapping",
        //   permissionAvailable: isValidRole("MENU_CONFIGURATION_MASTER_SCREENSAVER") && userRoleCode === "ROLE_SUPER_ADMIN",
        // }
      ],
    },
    {
      label: "User Management",
      icon: faUserGear,
      iconType: "fontawesome",
      subMenu: true,
      to: "",
      permissionAvailable: isValidRole("MENU_USER_MANAGEMENT") && (userRoleCode === "ROLE_SUPER_ADMIN" ? true : viewTypePermission),
      childMenu: [
        {
          subLabel: "Users",
          to: "/hms/userList",
          permissionAvailable: isValidRole("MENU_USERS"),
        },
        {
          subLabel: "Create User",
          to: "/hms/createEditUser",
          permissionAvailable: isValidRole("MENU_USER_CREATE"),
        },
        {
          subLabel: "Roles",
          to: "/hms/roles",
          permissionAvailable: isValidRole("MENU_ROLES"),
        },
        {
          subLabel: "Roles And Permissions",
          to: "/hms/rolesPermissions",
          permissionAvailable: isValidRole("MENU_ROLES_AND_PERMISSIONS"),
        },
        {
          subLabel: "User Privileges",
          to: "/hms/userPrivilege",
          permissionAvailable: isValidRole("MENU_USER_PRIVILEGES"),
        },
      ],
    },
  ];

  const toggleDropdown = (index) => {
    // setIsOpen(!isOpen);
    setOpenSubmenuIndex(openSubmenuIndex === index ? null : index);
  };

  const closeSubMenu = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  const hoverTimeout = useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(hoverTimeout.current); // cancel any pending collapse
    closeSubMenu();
    setShowMenu(true);
    setCollapseEnter(true);
    setCollapseLeave(false);
  };

  const handleMouseLeave = () => {
    hoverTimeout.current = setTimeout(() => {
      closeSubMenu();
      setShowMenu(false);
      setCollapseEnter(false);
      setCollapseLeave(true);
    }, 150); // delay prevents accidental rapid toggle
  };


  return (
    <div
      className={`sideNav ${collapseEnter ? 'show-menu-hover' : ''} ${collapseLeave ? 'show-menu-collapse' : ''}`}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
    >
      <div className="sideNav-items">
        {mockData?.map((data, index) => (
          <Fragment>
            {data?.permissionAvailable ? (
              <div key={index} className="side-menu-items">
                <div className="side-menu">
                  <div className="menu-links">
                    {data.subMenu ? (
                      <div>
                        <div
                          className="sub-menu sidenav-inactive"
                          onClick={() => toggleDropdown(index)}
                        >
                          <FontAwesomeIcon
                            icon={data?.icon}
                            onMouseEnter={() => setShowMenu(true)}
                          />
                          {showMenu && (
                            <span className="menu-item">
                              <h5>{data.label}</h5>
                              {openSubmenuIndex === index ? (
                                <span className="menu_up_arrow">
                                  <FontAwesomeIcon icon={faAngleUp} />
                                </span>
                              ) : (
                                <span className="menu_down_arrow">
                                  <FontAwesomeIcon icon={faAngleDown} />
                                </span>
                              )}
                            </span>
                          )}
                        </div>

                        {openSubmenuIndex === index && showMenu && (
                          <div className="menu_options_open">
                            <span className="menu_options">
                              {data?.childMenu?.map((child, childIndex) => {
                                return (
                                  <Fragment>
                                    {child?.permissionAvailable ? (
                                      <div
                                        key={childIndex}
                                        className={`sub_menu ${isActive === child.to
                                          ? "sidenav-active"
                                          : "sidenav-inactive"
                                          } `}
                                      >
                                        <Link to={child.to} >
                                          <h5>{child?.subLabel}</h5>
                                        </Link>
                                      </div>
                                    ) : null}
                                  </Fragment>
                                );
                              })}
                            </span>
                          </div>
                        )}
                      </div>
                    ) : (
                      <Link
                        to={data.to}
                        className={`main-menu ${isActive === data.to
                          ? "sidenav-active"
                          : "sidenav-inactive"
                          } `}
                      // onClick={(e) => {
                      //   if (hotelChainId === null && userRoleCode !== "ROLE_SUPER_ADMIN") {
                      //     e.preventDefault();
                      //   }
                      // }}
                      >
                        {data?.iconType === "reactIcon" ? <MdOutlineContentPasteSearch className="cdsn-detail-icon" onMouseEnter={() => setShowMenu(true)} />
                          : <FontAwesomeIcon
                            icon={data?.icon}
                            onMouseEnter={() => setShowMenu(true)}
                          />}

                        {showMenu && <h5>{data.label}</h5>}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ) : null}
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export default SideNavigation;
